module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAqCAYAAAD1T9h6AAAAAXNSR0IArs4c6QAAAM1JREFUWAntl7ENwkAMRW3IILmKBZiD7RgEJBp2SA9SxI1y6IprHRfxtyL9NFfY+j9+/6TEWua5CfBR1eVX63Uvy9NeQlk6HCCL/PBlAoNE1skEssgP38MnMInqc0wDOleQD21IgARIAEBASykfgE+YxSStXcLUAcKH/xJzAMAtMS2YgIkHUGQCAMimRd8HvmYHiyRAAiRAAgaBvg88jHpa6SxyX2t9b71A3wduW00Z9ab68vjyV8JDKbKHCUTS9WgzAQ+lyB4mEEnXo/0HORgUD3Cb/NcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/daohang.png
// module id = eQEt
// module chunks = 25